var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/breadcrumb-macro.j2"] = require( "macros/breadcrumb-macro.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/category-breadcrumbs.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n\n";
env.getTemplate("macros/breadcrumb-macro.j2", false, "category/templates/category-breadcrumbs.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("breadcrumbMacro", t_1);
output += "\n\n<div class=\"dom-breadcrumbs\">\n";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"breadcrumbs")) {
output += "\n    ";
output += runtime.suppressValue((lineno = 6, colno = 36, runtime.callWrap(runtime.memberLookup((t_1),"buildBreadcrumb"), "breadcrumbMacro[\"buildBreadcrumb\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"breadcrumbs"),runtime.makeKeywordArgs({"core": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n";
;
}
output += "\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/category-breadcrumbs.j2"] , dependencies)